import axios from 'axios';

export const trialApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/trial`, withCredentials: true });
export const TRIAL_TOKEN_KEY = 'voxinity_trial_token';
export const readTrialToken = () => sessionStorage.getItem(TRIAL_TOKEN_KEY) || '';
export const saveTrialToken = (token) => sessionStorage.setItem(TRIAL_TOKEN_KEY, token);
export const trialError = (err) => typeof err?.response?.data?.detail === 'string'
  ? err.response.data.detail : 'Something went wrong. Please try again.';

export const startTrialGoogle = async () => {
  const { data } = await trialApi.post('/google/start');
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirect = `${window.location.origin}/free-trial/google?state=${encodeURIComponent(data.state)}`;
  window.location.assign(`https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`);
};